module.exports = __webpack_public_path__ + "img/547.978afa20.png";